import {Component, Input} from "@angular/core";
import {NotificationService} from "../../../../services/notificationService";
import util from "util";
import {DICTIONARY} from "../../../../dictionary";
import {TableQueryTemplatesService} from "../../../../services/tableQueryTemplatesService";

@Component({
	selector: 'table-query-templates-controls',
	templateUrl: './table-query-templates-controls.html',
})
export class TableQueryTemplatesControlsComponent {

	@Input() getCurrentQueryModelAsTemplateFn;

	constructor(public tableQueryTemplatesService:TableQueryTemplatesService,
				private ns:NotificationService) {
		this.tableQueryTemplatesService.templateUpdatedSuccessSubj.subscribe((template) => {
			if (template) {
				this.saveAsTemplateInput = null;
			}
		});
	}

	saveAsTemplateInput;
	dic = DICTIONARY;

	saveTableQueryTemplate = () => {
		const name = this.saveAsTemplateInput.name.trim();
		if (!name) {
			this.ns.showWarnMessage(util.format(this.dic.ERRORS.cannotBeEmpty, 'Template name field'))
			return;
		}

		const templateToSave = {
			name,
			query: this.getCurrentQueryModelAsTemplateFn()
		}

		this.tableQueryTemplatesService.saveTableQueryTemplate(templateToSave);
	}
}
